import styled from "styled-components";
export const SelectedProductContainer = styled.section`
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  margin: 20px 0;
  flex-wrap: wrap;
  overflow: hidden;
  position: relative;
  .edit-icon {
    font-size: 24px;
    position: absolute;
    top: 16px;
    left: 16px;
    cursor: pointer;
    color: #222;
  }
  .image {
    width: 27%;
    img {
      width: 100%;
    }
  }
  .content {
    width: 50%;
    padding: 16px;
    .title-area {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .labels {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 16px;
      .label {
        border-radius: 15px;
        border: solid 0 #050508;
        background-color: #dce5e5;
        font-size: 12px;
        font-weight: 500;
        padding: 6px 16px 2px 16px;
        margin-top: 6px;
        width: 100%;
      }
    }
    .description {
      font-size: 0.8em;
    }
    .date {
      color: #007d4d;
      margin-top: 8px;
    }
  }
  .price {
    background-color: #dce5e5;
    width: 23%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 32px;
    span {
      margin-bottom: 8px;
    }
  }

  @media only screen and (max-width: 1024px) {
    .image {
      width: 100%;
    }
    .content {
      width: 50%;
    }
    .price {
      width: 50%;
    }
  }
  @media only screen and (max-width: 760px) {
    .image {
      width: 100%;
    }
    .content {
      width: 100%;
    }
    .price {
      width: 100%;
      padding: 8px 16px;
    }
  }
`;
